// eslint-disable-next-line no-restricted-imports
import _ from 'lodash';

type IteratorFn<T> = ((item: T) => unknown) | keyof T;

export function uniq<T>(array: T[], iterator?: IteratorFn<T>): T[] {
    return _.uniqBy(array, iterator as IteratorFn<T>);
}
